// extracted by mini-css-extract-plugin
export default {"title":"ProductsTitle_title__SgIcx"};